var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoutCircleLineSystem = function SvgLogoutCircleLineSystem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 9.167h6.666v1.666H4.167v2.5L0 10l4.167-3.333v2.5ZM3.333 15H5.59a6.666 6.666 0 1 0 0-10H3.333A8.32 8.32 0 0 1 10 1.667 8.333 8.333 0 1 1 3.333 15Z",
    fill: "#999FB4"
  })));
};
export default SvgLogoutCircleLineSystem;